import $ from 'jquery';
import React from 'react';
import { renderRoot, unmountRoot } from '../../lib/react_root';
import loadData from '../../lib/bootstrapped_data';
import HereMap from '../../components/here_maps/HereMap';
import Place from '../../components/here_maps/markers/Place';

const AdministrationPlaces = {
  init() {
    this.renderMaps();
  },

  teardown() {
    const mapEl = window.document.getElementById('js-map-container');
    if (mapEl) {
      unmountRoot(mapEl);
    }
  },

  renderMaps() {
    const mapEl = $('#js-map-container');
    if (!mapEl.length) return;

    const place = loadData('place').data;

    renderRoot(
      <HereMap autoZoom noTraffic boundingBox={loadData('bbox')}>
        <Place place={place} />
      </HereMap>,
      mapEl.get(0)
    );
  }
}

export default AdministrationPlaces;
